import { render, staticRenderFns } from "./recommend-credit.vue?vue&type=template&id=73402696&scoped=true&"
import script from "./recommend-credit.vue?vue&type=script&lang=js&"
export * from "./recommend-credit.vue?vue&type=script&lang=js&"
import style0 from "./recommend-credit.vue?vue&type=style&index=0&id=73402696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73402696",
  null
  
)

export default component.exports